import n from "react";
import { Tooltip as l } from "@mui/material";
function a(t) {
  return t ? { "data-mui-internal-clone-element": !0 } : {};
}
const r = (t) => {
  const e = t.title.replace(/&#10;|\\n/g, `
`);
  return e.length > 140 && console.warn("Tooltip title should not span more than 140 characters"), e.split(`
`).length > 3 && console.warn("Tooltip title should not span more than 3 new lines"), /* @__PURE__ */ n.createElement(
    l,
    {
      id: t.id,
      "data-testid": t["data-testid"],
      title: /* @__PURE__ */ n.createElement("div", { style: { whiteSpace: "pre-line" } }, e),
      arrow: !0,
      PopperProps: {
        sx: { maxWidth: "300px" }
      },
      placement: t.placement
    },
    t.children
  );
};
export {
  r as T,
  a as g
};
